import api from '../api/client';

export const lotesService = {
  // Lotes
  async listarLotes(organizadorId, leilaoId) {
    const response = await api.get(`/organizadores/${organizadorId}/leiloes/${leilaoId}/lotes`);
    return response.data;
  },

  async obterLote(organizadorId, loteId) {
    const response = await api.get(`/organizadores/${organizadorId}/lotes/${loteId}`);
    return response.data;
  },

  async exportarVendas(organizadorId, { leilaoId, dataInicio, dataFim, formato } = {}) {
    const params = { formato: formato || 'xlsx' };
    if (leilaoId) params.leilao_id = leilaoId;
    if (dataInicio) params.data_inicio = dataInicio;
    if (dataFim) params.data_fim = dataFim;
    const response = await api.get(`/organizadores/${organizadorId}/lotes/exportar`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  async criarLote(organizadorId, loteData) {
    const response = await api.post(`/organizadores/${organizadorId}/lotes`, loteData);
    return response.data;
  },

  async atualizarLote(organizadorId, loteId, loteData) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}`, loteData);
    return response.data;
  },

  async atualizarPeso(organizadorId, loteId, peso) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/peso`, { peso });
    return response.data;
  },

  async salvarValorVenda(organizadorId, loteId, valorVendaUnidade, valorVendaTotal) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/valor-venda`, {
      valor_venda_unidade: valorVendaUnidade,
      valor_venda_total: valorVendaTotal,
    });
    return response.data;
  },

  async presignVideoLote(organizadorId, loteId, { kind = 'video', filename, content_type, file_size }) {
    const response = await api.post(`/organizadores/${organizadorId}/lotes/${loteId}/video/presign`, {
      kind, filename, content_type, file_size,
    });
    return response.data;
  },

  async confirmarVideoLote(organizadorId, loteId, key, kind = 'video') {
    const response = await api.post(`/organizadores/${organizadorId}/lotes/${loteId}/video/confirm`, { key, kind });
    return response.data;
  },

  async removerVideoLote(organizadorId, loteId) {
    const response = await api.delete(`/organizadores/${organizadorId}/lotes/${loteId}/video`);
    return response.data;
  },

  async presignVideoLotePendente(organizadorId, leilaoId, { kind = 'video', filename, content_type, file_size }) {
    const response = await api.post(`/organizadores/${organizadorId}/leiloes/${leilaoId}/video-lote/presign`, {
      kind, filename, content_type, file_size,
    });
    return response.data;
  },

  async confirmarVideoLotePendente(organizadorId, leilaoId, key, kind = 'video') {
    const response = await api.post(`/organizadores/${organizadorId}/leiloes/${leilaoId}/video-lote/confirm`, { key, kind });
    return response.data;
  },

  async marcarComoDefesa(organizadorId, loteId, dadosDefesa) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/defesa`, dadosDefesa);
    return response.data;
  },

  async desfazerNegociacao(organizadorId, loteId) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/desfazer-negociacao`);
    return response.data;
  },

  async alterarComissaoCustomBatch(organizadorId, data) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/comissao-custom-batch`, data);
    return response.data;
  },

  async removerDespesasBatch(organizadorId, data) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/despesas-removidas-batch`, data);
    return response.data;
  },

  async isentarDefesa(organizadorId, loteIds) {
    const response = await api.post(`/organizadores/${organizadorId}/lotes/isentar-defesa`, { lote_ids: loteIds });
    return response.data;
  },

  async desfazerIsencaoDefesa(organizadorId, loteIds) {
    const response = await api.post(`/organizadores/${organizadorId}/lotes/desfazer-isencao-defesa`, { lote_ids: loteIds });
    return response.data;
  },

  async candidatosIsencaoDefesa(organizadorId, leilaoId) {
    const response = await api.get(`/organizadores/${organizadorId}/leiloes/${leilaoId}/defesa/candidatos-isencao`);
    return response.data;
  },

  async obterHistorico(organizadorId, loteId) {
    const response = await api.get(`/organizadores/${organizadorId}/lotes/${loteId}/historico`);
    return response.data;
  },

  // Raças
  async listarRacas(organizadorId, { apenasAtivos = false } = {}) {
    const response = await api.get(`/organizadores/${organizadorId}/racas`, { params: apenasAtivos ? { apenas_ativos: true } : undefined });
    return response.data;
  },

  async criarRaca(organizadorId, racaData) {
    const response = await api.post(`/organizadores/${organizadorId}/racas`, racaData);
    return response.data;
  },

  // Tipos de Animais
  async listarTiposAnimais(organizadorId, { apenasAtivos = false } = {}) {
    const response = await api.get(`/organizadores/${organizadorId}/tipos-animais`, { params: apenasAtivos ? { apenas_ativos: true } : undefined });
    return response.data;
  },

  async criarTipoAnimal(organizadorId, tipoData) {
    const response = await api.post(`/organizadores/${organizadorId}/tipos-animais`, tipoData);
    return response.data;
  },

  async obterDadosTipoAnimal(organizadorId, tipoId) {
    const response = await api.get(`/organizadores/${organizadorId}/tipos-animais/${tipoId}`);
    return response.data;
  },

  // Idades
  async listarIdades(organizadorId, { apenasAtivos = false } = {}) {
    const response = await api.get(`/organizadores/${organizadorId}/idades`, { params: apenasAtivos ? { apenas_ativos: true } : undefined });
    return response.data;
  },

  async criarIdade(organizadorId, idadeData) {
    const response = await api.post(`/organizadores/${organizadorId}/idades`, idadeData);
    return response.data;
  },

  async atualizarIdade(organizadorId, idadeId, idadeData) {
    const response = await api.put(`/organizadores/${organizadorId}/idades/${idadeId}`, idadeData);
    return response.data;
  },

  async alternarStatusIdade(organizadorId, idadeId) {
    const response = await api.patch(`/organizadores/${organizadorId}/idades/${idadeId}/toggle`);
    return response.data;
  },

  async excluirIdade(organizadorId, idadeId) {
    const response = await api.delete(`/organizadores/${organizadorId}/idades/${idadeId}`);
    return response.data;
  },

  // Raças
  async atualizarRaca(organizadorId, racaId, racaData) {
    const response = await api.put(`/organizadores/${organizadorId}/racas/${racaId}`, racaData);
    return response.data;
  },

  async alternarStatusRaca(organizadorId, racaId) {
    const response = await api.patch(`/organizadores/${organizadorId}/racas/${racaId}/toggle`);
    return response.data;
  },

  async excluirRaca(organizadorId, racaId) {
    const response = await api.delete(`/organizadores/${organizadorId}/racas/${racaId}`);
    return response.data;
  },

  // Tipos de Animais
  async atualizarTipoAnimal(organizadorId, tipoId, tipoData) {
    const response = await api.put(`/organizadores/${organizadorId}/tipos-animais/${tipoId}`, tipoData);
    return response.data;
  },

  async alternarStatusTipoAnimal(organizadorId, tipoId) {
    const response = await api.patch(`/organizadores/${organizadorId}/tipos-animais/${tipoId}/toggle`);
    return response.data;
  },

  async excluirTipoAnimal(organizadorId, tipoId) {
    const response = await api.delete(`/organizadores/${organizadorId}/tipos-animais/${tipoId}`);
    return response.data;
  },

  // Lotes
  async listarLotesPorLeilao(organizadorId, leilaoId) {
    const response = await api.get(`/organizadores/${organizadorId}/leiloes/${leilaoId}/lotes`);
    return response.data;
  },

  async criarLote(organizadorId, loteData) {
    const response = await api.post(`/organizadores/${organizadorId}/lotes`, loteData);
    return response.data;
  },

  async excluirLote(organizadorId, loteId) {
    const response = await api.delete(`/organizadores/${organizadorId}/lotes/${loteId}`);
    return response.data;
  },

  async refugarLote(organizadorId, loteId, qtdRefugo) {
    const response = await api.post(
      `/organizadores/${organizadorId}/lotes/${loteId}/refugar`,
      { qtd_refugo: qtdRefugo }
    );
    return response.data;
  },

  async listarLotesRefugo(organizadorId, loteId) {
    const response = await api.get(
      `/organizadores/${organizadorId}/lotes/${loteId}/refugos`
    );
    return response.data;
  },

  async doarNovamenteLote(organizadorId, loteId) {
    const response = await api.post(
      `/organizadores/${organizadorId}/lotes/${loteId}/doar-novamente`
    );
    return response.data;
  },

  // Animais do lote (fluxo cavalo)
  async listarAnimais(organizadorId, loteId) {
    const response = await api.get(`/organizadores/${organizadorId}/lotes/${loteId}/animais`);
    return response.data;
  },

  async salvarAnimais(organizadorId, loteId, animais) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/animais`, animais);
    return response.data;
  },

  // Cadastro mestre reutilizável de animais (fluxo cavalo — busca por nome pra
  // pré-preencher os campos de um animal já cadastrado em leilões anteriores)
  async buscarAnimaisCadastro(organizadorId, termo) {
    const response = await api.get(`/organizadores/${organizadorId}/animais-cadastro`, {
      params: { search: termo },
    });
    return response.data;
  },

  // Listagem completa do cadastro mestre (tela Cadastros > Animais)
  async listarAnimaisCadastro(organizadorId, { search = '', tipoAnimalId = '' } = {}) {
    const response = await api.get(`/organizadores/${organizadorId}/animais-cadastro/lista`, {
      params: { search, tipo_animal_id: tipoAnimalId || undefined },
    });
    return response.data;
  },

  async atualizarAnimalCadastro(organizadorId, animalId, dados) {
    const response = await api.put(`/organizadores/${organizadorId}/animais-cadastro/${animalId}`, dados);
    return response.data;
  },

  // Preview do valor de defesa (fluxo cavalo) — calcula sem salvar, respeitando
  // se o leilão usa tabela de faixas fixas ou percentual de comissão.
  async previewDefesa(organizadorId, loteId, { valorTotal, comissaoId } = {}) {
    const response = await api.get(`/organizadores/${organizadorId}/lotes/${loteId}/preview-defesa`, {
      params: { valor_total: valorTotal, comissao_id: comissaoId || undefined },
    });
    return response.data;
  },

  // Vendedores do lote (fluxo cavalo — múltiplos donos, cada um com sua %)
  async listarVendedoresLote(organizadorId, loteId) {
    const response = await api.get(`/organizadores/${organizadorId}/lotes/${loteId}/vendedores`);
    return response.data;
  },

  async salvarVendedoresLote(organizadorId, loteId, vendedores) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/vendedores`, vendedores);
    return response.data;
  },

  // Compradores do lote (fluxo cavalo — lote vendido para N compradores, cada
  // um com sua % de participação e sua própria fazenda)
  async listarCompradoresLote(organizadorId, loteId) {
    const response = await api.get(`/organizadores/${organizadorId}/lotes/${loteId}/compradores`);
    return response.data;
  },

  async salvarCompradoresLote(organizadorId, loteId, compradores) {
    const response = await api.put(`/organizadores/${organizadorId}/lotes/${loteId}/compradores`, compradores);
    return response.data;
  },
};